import { Selector } from '@reduxjs/toolkit';
import { tSharedAppState, tSharedStore } from './types';

export const selectShared: Selector<tSharedAppState, tSharedStore> = (state) =>
  state.shared;
